import axios from 'axios';
import {
	useEffect,
	useState,
} from 'react';
import {
	Alert,
	Spin,
} from 'antd';

// Tournament details from the admin portal, fetched fresh on each page so registration status is current.
export function useTournamentSettings() {
	const [settings, setSettings] = useState(null);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		let active = true;

		axios.get('/api/settings')
			.then(({data}) => active && setSettings(data))
			.catch(() => active && setFailed(true));

		return () => {
			active = false;
		};
	}, []);

	return {settings, failed};
}

export function SettingsLoading({failed}) {
	if (failed) {
		return <Alert type="error" showIcon message="Something went wrong loading this page. Please reload and try again." />;
	}

	return (
		<div style={ {textAlign: 'center', padding: 48} }>
			<Spin size="large" />
		</div>
	);
}
